import React from "react";
import "../../../../css/Turismo/turismo.css";
import "../../../../css/Turismo/pasajes-paseos.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";

// Carruseles de imágenes para cada paseo
const carousels = [
  {
    nombre: "Pasaje Peatonal Héroes de Malvinas",
    images: [
      require("../../../img/Pasajes/Pasaje101.jpeg"),
      require("../../../img/Pasajes/Pasaje21.jpeg"),
    ],
    maps: "https://maps.app.goo.gl/EFQ1PDpEvhArojrn7",
    direccion: <>Cura Larocca.</>,
    id: "carouselPasajeMalvinas",
  },
  {
    nombre: "Paseo de la Virgen",
    images: [
      require("../../../img/Pasajes/paseo-de-la-virgen-1.jpg"),
      require("../../../img/Pasajes/paseo-de-la-virgen-2.jpg"),
      require("../../../img/Pasajes/paseo-de-la-virgen-3.jpg"),
      require("../../../img/Pasajes/paseo-de-la-virgen-4.jpg"),
    ],
    maps: "https://maps.app.goo.gl/7tp5Kt5Rx8CZgviM9",
    direccion: <>Juan José Paso & Avenida Emilio Olmos.</>,
    id: "carouselPaseoVirgen",
  },
  {
    nombre: "Paseo del Deporte",
    images: [
      require("../../../img/Pasajes/paseo-del-deporte-1.jpg"),
      require("../../../img/Pasajes/paseo-del-deporte-3.jpg"),
      require("../../../img/Pasajes/paseo-del-deporte-3.jpg"),
    ],
    maps: "https://maps.app.goo.gl/E3SDQGfbc4FcEMgR6",
    direccion: <>21 de Agosto & Avenida Emilio Olmos.</>,
    id: "carouselPaseoDeporte",
  },
  {
    nombre: "Paseo de la Estación",
    images: [
      require("../../../img/Pasajes/paseo-de-la-estacion-1.jpg"),
      require("../../../img/Pasajes/paseo-de-la-estacion-2.jpg"),
      require("../../../img/Pasajes/paseo-de-la-estacion-3.jpg"),
    ],
    maps: "https://maps.app.goo.gl/X6zKas5sKytbcvRSA",
    direccion: <>Roque Sáenz Peña & Rivadavia.</>,
    id: "carouselPaseoEstacion",
  },
  {
    nombre: "Paseo Rodolfo Depetris",
    images: [
      require("../../../img/Pasajes/paseo-depetris-1.jpg"),
      require("../../../img/Pasajes/paseo-depetris-2.jpg"),
      require("../../../img/Pasajes/paseo-depetris-3.jpg"),
    ],
    maps: "https://maps.app.goo.gl/YnSpZitFw93Yoe6k6",
    direccion: <>Leandro N. Alem & Av. Olmos</>,
    id: "carouselPaseoDepetris",
  },
  {
    nombre: "Paseo Ex Combatiente Milton Pablo Galindez",
    images: [
      require("../../../img/Pasajes/paseo-galindez-1.jpg"),
      require("../../../img/Pasajes/paseo-galindez-2.jpg"),
      require("../../../img/Pasajes/paseo-galindez-3.jpg"),
    ],
    maps: "https://maps.app.goo.gl/GsrKKHicLtDFnmyf6",
    direccion: <>Roque Sáenz Peña</>,
    id: "carouselPaseoGalindez",
  },
  {
    nombre: "Paseo San Pietro Val Lemina",
    images: [
      require("../../../img/Pasajes/paseo-san-prieto-1.jpg"),
      require("../../../img/Pasajes/paseo-san-prieto-2.jpg"),
    ],
    maps: "https://maps.app.goo.gl/f4jhWsyL4oMKgCGk7",
    direccion: <>Ruta Nacional 10 km.</>,
    id: "carouselPaseoSanPietro",
  },
];

const PasajesYPaseos = () => (
  <div>
    <div
      className="pasajes-paseos text-center"
      style={{
        backgroundImage: `url(${require("../../../img/Av-Olmos1.jpeg")})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundPositionY: "-160px",
        paddingTop: 100,
        paddingBottom: 100,
        backgroundAttachment: "fixed",
        position: "relative",
        height: 350,
        marginBottom: 30,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: "rgba(0,0,0,0.3)",
          zIndex: 1,
        }}
      />
    </div>
    <div className="container frm-pasajes-paseos">
      <h6 className="titulo-pasajes text-center">Pasajes y Paseos de nuestra ciudad</h6>
      <br />
      <div className="row">
        {carousels.map((paseo, idx) => (
          <div className="col-12" key={paseo.id}>
            <div className="vista-paseos">
              <div className="row">
                <h4>{paseo.nombre}</h4>
                <section className="col-12 col-md-6">
                  <div className="imagen-lugares">
                    <div id={paseo.id} className="carousel slide" data-bs-ride="carousel">
                      <div className="carousel-inner">
                        {paseo.images.map((img, i) => (
                          <div className={`carousel-item${i === 0 ? " active" : ""}`} key={i}>
                            <img src={img} alt={paseo.nombre + " " + (i + 1)} />
                          </div>
                        ))}
                      </div>
                      {paseo.images.length > 1 && (
                        <>
                          <button className="carousel-control-prev" type="button" data-bs-target={`#${paseo.id}`} data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Anterior</span>
                          </button>
                          <button className="carousel-control-next" type="button" data-bs-target={`#${paseo.id}`} data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Siguiente</span>
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </section>
                <section className="col-12 col-md-6 align-self-center">
                  <a href={paseo.maps} target="_blank" rel="noopener noreferrer">
                    <div className="informacion-pasajes-paseos text-center">
                      <FontAwesomeIcon icon={faLocationDot} style={{ fontSize: 60, marginBottom: 20 }} />
                      <br />
                      <p>{paseo.direccion}</p>
                    </div>
                  </a>
                </section>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default PasajesYPaseos;